import * as Comlink from "comlink";
/**
 * Assumptions:
 * - User will either not call this function or can call multiple times
 * - So worker will be cached with timelimit 0f 10 minutes
 * - Since it is called when editing objects, heightmap are accessed frequently, so no Zero-Copy transfer will be implemented
 */
const CACHE_TIME_LIMIT = 10 * 60 * 1000; // 10 minutes
// Worker pool (singleton pattern)
let cachedWorker = null;
let cachedWorkerAPI = null;
let idleTimeout = null;
function getWorker() {
    if (!cachedWorker) {
        cachedWorker = new Worker(new URL("../worker/volume-calculation-worker", import.meta.url), { type: "module" });
        cachedWorkerAPI = Comlink.wrap(cachedWorker);
    }
    // Reset idle timer
    if (idleTimeout)
        clearTimeout(idleTimeout);
    // Auto-cleanup after 10 minutes of inactivity
    idleTimeout = setTimeout(() => {
        cleanup();
    }, CACHE_TIME_LIMIT);
    return cachedWorkerAPI;
}
function cleanup() {
    // clean up is called after timeout, however this code is added for safety
    if (idleTimeout) {
        clearTimeout(idleTimeout);
        idleTimeout = null;
    }
    if (cachedWorkerAPI)
        cachedWorkerAPI[Comlink.releaseProxy]();
    if (cachedWorker)
        cachedWorker.terminate();
    cachedWorker = null;
    cachedWorkerAPI = null;
}
export var VolumeCalculationUtils;
(function (VolumeCalculationUtils) {
    async function calculateVolume(data) {
        try {
            const workerAPI = getWorker();
            let serializableData;
            const serializeHeightMap = (heightMap) => {
                return {
                    boxMin: [...heightMap.boxMin],
                    boxMax: [...heightMap.boxMax],
                    boxesInX: heightMap.boxesInX,
                    boxesInY: heightMap.boxesInY,
                    heights: heightMap.heights,
                    minIndexes: [...heightMap.minIndexes],
                    maxIndexes: [...heightMap.maxIndexes],
                    boxSize: heightMap.boxSize,
                };
            };
            if ("specifiedPlaneAltitude" in data) {
                serializableData = {
                    specifiedPlaneAltitude: data.specifiedPlaneAltitude,
                    targetHeightMap: serializeHeightMap(data.targetHeightMap),
                };
            }
            else {
                serializableData = {
                    sourceHeightMap: serializeHeightMap(data.sourceHeightMap),
                    targetHeightMap: serializeHeightMap(data.targetHeightMap),
                };
            }
            //
            const volume = await workerAPI(serializableData);
            return volume;
        }
        catch (error) {
            console.error("Error calculating volume:", error);
            cleanup();
            return {
                cutVolume: 0,
                fillVolume: 0,
                error: error,
            };
        }
    }
    VolumeCalculationUtils.calculateVolume = calculateVolume;
})(VolumeCalculationUtils || (VolumeCalculationUtils = {}));
//# sourceMappingURL=volume-calculation-utils.js.map